document.addEventListener('DOMContentLoaded', function () {
    //get price
    const priceElement = document.querySelector('.product-price--original')
    if (!priceElement) return

    const priceText = priceElement.textContent.trim()
    const priceNumber = parseFloat(priceText.replace(/[^0-9.]/g, ''))

    const deductible = getDeductible(priceNumber)
    document.getElementById('deductibleAmount').innerText = deductible

    const itgAssemblyLocationIneligibleMessage = document.body ? document.body.getAttribute('data-assembly-location-ineligible-message') : '';
    const itgFreeGiftLabel = document.body ? document.body.getAttribute('data-free-gift-label') : '';
    const itgWarrantySeeBenefitsHtml = document.body ? document.body.getAttribute('data-warranty-see-benefits-html') : '';
    const itgWarrantyHideBenefitsHtml = document.body ? document.body.getAttribute('data-warranty-hide-benefits-html') : '';

    // see benefit toggle
    let benefitToggle = document.getElementById('toggleBenefits')
    let benefits = document.getElementById('warrantyBenefits')

    benefitToggle.addEventListener('click', function (e) {
        e.preventDefault()
        if (benefits.style.display === 'none') {
            benefits.style.display = 'block'
            benefitToggle.innerHTML = itgWarrantyHideBenefitsHtml
        } else {
            benefits.style.display = 'none'
            benefitToggle.innerHTML = itgWarrantySeeBenefitsHtml
        }
    })

    const warrantyVariantInfo = document.getElementById('warranty-variant-info')
    const addWarrantyButton = document.getElementById('addWarrantyToCartButton')
    let warrantyVariantId

    if (addWarrantyButton) {
        addWarrantyButton.addEventListener('click', addWarrantyToCart)
    }
    async function displayWarrantyProduct() {
        const variantInfoElement = document.getElementById(
            'variantInfoWarranty'
        )
        if (!variantInfoElement) {
            return
        }
        const gid = variantInfoElement.getAttribute('data-warranty')
        if (!gid) {
            displayNoWarrantyError()
            return
        }
        const variantId = gid.split('/').pop()

        // Fetch warranty variant details.
        const warrantyVariantData = await fetchWarrantyVariantDetails(variantId)
        if (warrantyVariantData) {
            // Display the variant information in the designated element.
            const warrantyHtml = `<span>Add 5-year Term Protection Plan for $${warrantyVariantData.formattedPrice}</span>`
            if (warrantyVariantInfo) {
                warrantyVariantInfo.innerHTML = warrantyHtml
            }
            toggleAddToCartButton(true)
            toggleLoading(false)
        } else {
            displayNoWarrantyError()
        }
    }

    async function fetchWarrantyVariantDetails(variantId) {
        try {
            const response = await fetch(`/variants/${variantId}.js`)
            if (!response.ok) {
                displayUnexpectedError()
                return null
            }
            const variant = await response.json()
            warrantyVariantId = variant.id
            return {
                title: variant.title,
                formattedPrice: (variant.price / 100).toFixed(2),
            }
        } catch (error) {
            console.error('Error fetching warranty variant details:', error)
            displayNoWarrantyError()
            return null
        }
    }

    function addWarrantyToCart() {
        addItemToCart().then(() => {
            updateCartContents({ showOverlay: true })
        })
    }

    function addItemToCart() {
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                items: [{ quantity: 1, id: warrantyVariantId }],
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to add item to cart')
                }
                return response.json()
            })
            .catch((error) => {
                console.error('Error adding item to cart:', error)
                displayCartAdditionError()
            })
    }


    function updateCartQty(item, newQty){

        let alert = null;

        document.getElementById('AjaxCartForm').classList.add('processing');
        if ( document.getElementById('AjaxCartForm').querySelector('.alert') ) {
            document.getElementById('AjaxCartForm').querySelector('.alert').remove();
        }

        const body = JSON.stringify({
            line: parseInt(item.dataset.line),
            quantity: newQty
        });

        fetch(KROWN.settings.routes.cart_change_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
                body
            })
            .then(response => response.json())
            .then(response => {
                if ( response.status == 422 ) {
                    // wrong stock logic alert
                    alert = document.createElement('span');
                    alert.classList.add('alert', 'alert--error');
                    if ( typeof response.description === 'string' ) {
                        alert.innerHTML = response.description;
                    } else {
                        alert.innerHTML = response.message;
                    }
                }
                return fetch('?section_id=helper-cart');
            })
            .then(response => response.text())
            .then(text => {

                const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
                const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
                const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

                const cartItems = document.getElementById('AjaxCartForm');
                cartItems.innerHTML = cartFormInnerHTML;
                cartItems.ajaxifyCartItems();

                document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
                    elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
                });
                document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
                    elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
                });

                if ( alert !== null ) {	
                    document.getElementById('AjaxCartForm').prepend(alert);
                } 

                document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

                const event = new Event('cart-updated');
                document.getElementById('AjaxCartForm').dispatchEvent(event);

            })
            .catch(e => {
                console.log(e);
                let alert = document.createElement('span');
                alert.classList.add('alert', 'alert--error');
                alert.textContent = KROWN.settings.locales.cart_general_error;
                document.getElementById('AjaxCartForm').prepend(alert);
            })
            .finally(() => {
                document.getElementById('AjaxCartForm').classList.remove('processing');
            });
    }

    function ajaxifyCartItems(cartItemsContainer) {
        const form = cartItemsContainer.querySelector('form');

        cartItemsContainer.querySelectorAll('[data-js-cart-item]').forEach(item => {
            const remove = item.querySelector('.remove');
            if (remove) {       
                remove.dataset.href = remove.getAttribute('href');
                remove.setAttribute('href', '');
                remove.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.updateCartQty(item, 0); // Assuming you have updateCartQty defined elsewhere
  
                });
            }

        });
    }

    function updateCartContents({ showOverlay = false } = {}) {
        let alert = null;

        fetch('?section_id=helper-cart')
            .then((response) => response.text())
            .then((text) => {

                const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
                const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
                const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

                const cartItems = document.getElementById('AjaxCartForm');
                cartItems.innerHTML = cartFormInnerHTML;
                ajaxifyCartItems(cartItems);

                document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
                    elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
                });
                document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
                    elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
                });

                if ( alert !== null ) {	
                    document.getElementById('AjaxCartForm').form.prepend(alert);
                } 

                document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

                // const parser = new DOMParser()
                // const doc = parser.parseFromString(text, 'text/html')
                // const cartForm = doc.getElementById('AjaxCartForm').innerHTML
                // const cartSubtotal =
                //     doc.getElementById('AjaxCartSubtotal').innerHTML

                // document.getElementById('AjaxCartForm').innerHTML = cartForm
                // document.getElementById('AjaxCartSubtotal').innerHTML =
                //     cartSubtotal

                // document
                //     .querySelectorAll('[data-header-cart-count]')
                //     .forEach((element) => {
                //         element.textContent = document.querySelector(
                //             '#AjaxCartForm [data-cart-count]'
                //         ).textContent
                //     })
                // document
                //     .querySelectorAll('[data-header-cart-total]')
                //     .forEach((element) => {
                //         element.textContent = document.querySelector(
                //             '#AjaxCartForm [data-cart-total]'
                //         ).textContent
                //     })

                if (showOverlay) {
                    showCartOverlay()
                }

                let storedCartPrice = parseFloat(localStorage.getItem('loadedCartPrice')) || 0;

						console.log('Stored cart price from localStorage:', storedCartPrice);

						console.log("Cart successfully updated");

                        // console.log( cartSubtotal , "inside assembly");
                        
                        let subTotalElem =  document.getElementById('AjaxCartSubtotal');
                        if (!subTotalElem) return;

                        let subTotalAmt = subTotalElem.querySelector('.cart__total').getAttribute('data-total-price');
                        console.log('Subtotal amount:', subTotalAmt);
					

						let cartPrice = parseFloat(subTotalAmt.replace(/,/g, '').trim());
						console.log(isNaN(cartPrice), "cartPrice", cartPrice);

						const mainProgressWrapper = document.querySelector('.cart_drawer_progress_bar_inner_wrapper');
						if (!mainProgressWrapper) return;

						const cartBar = mainProgressWrapper.querySelector(".cart_drawer_progress_bar");
						if (!cartBar) return;

						console.log(subTotalAmt);

                        // assembly service js
                        
                        
                        let estimateShippingBtn = document.querySelector('.js-estimate-shipping');
                        const cartWrapper = document.querySelector('#site-cart-sidebar .cart-form');
                        const mainCartWrapper = document.querySelector('.template-cart .cart-section');

                        console.log(cartWrapper);
                        console.log(mainCartWrapper);

                        // if (!cartWrapper || !mainCartWrapper) return;

                        console.log("after if");

                        const checkEligibilityInLocalStorage = () => {
                            const eligibility = localStorage.getItem('eligibility');
                            return eligibility?.toLowerCase() === 'true' ? true
                                : eligibility?.toLowerCase() === 'false' ? false
                                : null;
                        };                    

                        const toggleAssemblyInCart = (isEligible) => {

                            if (cartWrapper) cartWrapper.classList.toggle('hide_assembly_variants', !isEligible);
                            if (mainCartWrapper) mainCartWrapper.classList.toggle('hide_assembly_variants', !isEligible);

                            // Get main wrappers (safely)
                            const mainCartDrawerWrapper = cartWrapper?.querySelector(".cart__items");
                            const mainCartPageWrapper = mainCartWrapper?.querySelector(".cart-form__items");

                            let hasAssemblyMessage = false;

                            // --- Process main cart page items ---
                            if (mainCartPageWrapper) {
                                const itemWrappers = mainCartPageWrapper.querySelectorAll('.cart-form-item');

                                itemWrappers.forEach(wrapper => {
                                    const title = (wrapper.dataset.title || "").toLowerCase();

                                    if (title.includes("assembly services")) {
                                        if (!isEligible) {
                                            if (!wrapper.querySelector('.assembly-service-msg')) {
                                                const msg = document.createElement('p');
                                                msg.className = 'assembly-service-msg';
                                                msg.textContent = itgAssemblyLocationIneligibleMessage;
                                                wrapper.appendChild(msg);
                                            }
                                            hasAssemblyMessage = true;
                                        } else {
                                            const existingMsg = wrapper.querySelector('.assembly-service-msg');
                                            if (existingMsg) existingMsg.remove();
                                        }
                                    }
                                });
                            }

                            // --- Process cart drawer items ---
                            if (mainCartDrawerWrapper) {
                                const itemWrappers = mainCartDrawerWrapper.querySelectorAll('.itg_cart_item_wrapper');

                                itemWrappers.forEach(wrapper => {
                                    const cartItem = wrapper.querySelector('.cart-item');
                                    if (!cartItem) return;

                                    const title = (cartItem.dataset.title || "").toLowerCase();

                                    if (title.includes("assembly services")) {
                                        if (!isEligible) {
                                            if (!wrapper.querySelector('.assembly-service-msg')) {
                                                const msg = document.createElement('p');
                                                msg.className = 'assembly-service-msg';
                                                // msg.textContent = "It is no longer valid for the updated location";
                                                msg.textContent = itgAssemblyLocationIneligibleMessage;
                                                wrapper.appendChild(msg);
                                            }
                                            hasAssemblyMessage = true;
                                        } else {
                                            const existingMsg = wrapper.querySelector('.assembly-service-msg');
                                            if (existingMsg) existingMsg.remove();
                                        }
                                    }
                                });
                            }

                            // --- Disable all checkout buttons if needed ---
                            const checkoutBtns = document.querySelectorAll('button#CheckOut');
                            checkoutBtns.forEach(btn => {
                                btn.disabled = hasAssemblyMessage;
                                btn.style.opacity = hasAssemblyMessage ? 0.5 : 1;
                                btn.style.pointerEvents = hasAssemblyMessage ? 'none' : 'auto';
                            });
                        };

                        setTimeout(() => {
                            toggleAssemblyInCart(checkEligibilityInLocalStorage());
                        }, 500);

                        // assembly service js

						const maxAmountPrice = parseFloat(cartBar.getAttribute("data-maxamt"));
						if (isNaN(maxAmountPrice) || maxAmountPrice <= 0) return;

						const allSteps = mainProgressWrapper.querySelectorAll(".progbar_counter");

						(async () => {
							// Fetch current cart
							const cartResponse = await fetch('/cart.js');
							const cart = await cartResponse.json();

							let allProductsHTML = '';

							const mainProgressWrapper = document.querySelector('.cart_drawer_progress_bar_inner_wrapper');
							if (!mainProgressWrapper) return;

							const cartBar = mainProgressWrapper.querySelector(".cart_drawer_progress_bar");
							if (!cartBar) return;

							const maxAmountPrice = parseFloat(cartBar.getAttribute("data-maxamt"));
							const subTotalElem = document.getElementById('AjaxCartSubtotal')?.querySelector('.cart__total');
							const cartPrice = parseFloat(subTotalElem?.getAttribute("data-total-price")?.replace(/,/g, '').trim() || 0);

							const allSteps = mainProgressWrapper.querySelectorAll(".progbar_counter");
							if (!allSteps.length) return;

                            // allSteps.forEach((step, index) => {
							// 	const stepAmount = parseFloat(step.getAttribute("data-amount"));
							// 	if (isNaN(stepAmount) || maxAmountPrice <= 0) return;

							// 	step.style.left = Math.round((stepAmount / maxAmountPrice) * 100) + "%";

							// 	const productElem = step.querySelector(".product_or_discount");
							// 	if (!productElem) return;

							// 	const type = productElem.getAttribute("data-product-or-discount");
							// 	const productVariantId = productElem.getAttribute("data-product-id");
							// 	const wrapperId = `cart_drawer_free_product_wrapper_step_${index}`;

							// 	// -----------------------------
							// 	// IF (cartPrice >= stepAmount)
							// 	// -----------------------------
							// 	if (cartPrice >= stepAmount && type === "product") {

							// 		const hasFreeItem = cart.items.some(item => {
							// 			const id = item.id.toString().replace("item-", "");
							// 			return id === productVariantId.toString() && Number(item.price) === 0;
							// 		});

							// 		const hasPaidItem = cart.items.some(item => {
							// 			const id = item.id.toString().replace("item-", "");
							// 			return id === productVariantId.toString() && Number(item.price) > 0;
							// 		});

							// 		console.log(hasFreeItem, "hasFreeItem (price=0)");
							// 		console.log(hasPaidItem, "hasPaidItem (price>0)");

							// 		// Rule: DO NOT render if a free version already exists
							// 		const shouldRender = !hasFreeItem;

							// 		if (shouldRender) {
							// 			allProductsHTML += `
							// 				<div class="single_step_product_wrapper" id="${wrapperId}">
							// 					<div class="free_product_wrapper_inner">
							// 						${productElem.innerHTML}
							// 					</div>
							// 				</div>`;
							// 		}
							// 	}

							// 	// -----------------------------
							// 	// ELSE (cartPrice < stepAmount)
							// 	// -----------------------------
							// 	else {

							// 		// 1. Remove accordion
							// 		const mainAccordion = document.querySelector('.main_free_product_accordion_wrapper');
							// 		if (mainAccordion) {
							// 			const productWrapper = mainAccordion.querySelector(`#${wrapperId}`);
							// 			if (productWrapper) productWrapper.remove();
							// 		}

							// 		// 2. Remove ONLY free version from cart
							// 		if (type === "product") {

							// 			// Find all matched items
							// 			const matchedItems = cart.items.filter(item => {
							// 				const id = item.id.toString().replace("item-", "");
							// 				return id === productVariantId.toString();
							// 			});

							// 			console.log(matchedItems , "matchedItems in else part") ;

							// 			matchedItems.forEach(item => {

							// 				console.log(item.price , "each item Price in else");
											
							// 				const price = Number(item.price);
							// 				if (price === 0) {
							// 					console.log("Removing free item:", item.id);
							// 					removeProductFromCart(productVariantId);
							// 				} else {
							// 					console.log("Keeping paid item:", item.id);
							// 				}
							// 			});
							// 		}
							// 	}
							// });

                            allSteps.forEach((step, index) => {
								const stepAmount = parseFloat(step.getAttribute("data-amount"));
								if (isNaN(stepAmount) || maxAmountPrice <= 0) return;

								step.style.left = Math.round((stepAmount / maxAmountPrice) * 100) + "%";

								const productElem = step.querySelector(".product_or_discount");
								if (!productElem) return;

								const type = productElem.getAttribute("data-product-or-discount");
								const productVariantId = productElem.getAttribute("data-product-id");
								const wrapperId = `cart_drawer_free_product_wrapper_step_${index}`;

                                const productIdOnly = productElem.querySelector('.cart_free_product_wrapper')?.getAttribute("data-product-id");

                                // -----------------------------
                                // IF (cartPrice >= stepAmount)
                                // -----------------------------

                                if (cartPrice >= stepAmount && type === "product") {

                                    // Check ANY variant of the same product
                                    const hasFreeItem = cart.items.some(item => {
                                        console.log(item.product_id , "item.product_id" );
                                        console.log(productVariantId , "Product-variant_id" );
                                        console.log(productIdOnly , "Product_id" );
                                        return item.product_id.toString() === productIdOnly.toString() && Number(item.price) === 0;
                                    });

                                    const hasPaidItem = cart.items.some(item => {
                                        console.log(item.product_id , "item.product_id" );
                                        console.log(productVariantId , "Product-variant_id" );
                                        console.log(productIdOnly , "Product_id" );
                                        return item.product_id.toString() === productIdOnly.toString() && Number(item.price) > 0;
                                    });

                                    console.log(hasFreeItem, "hasFreeItem (price=0)");
                                    console.log(hasPaidItem, "hasPaidItem (price>0)");

                                    // If ANY variant exists → do NOT render
                                    // const shouldRender = !hasFreeItem && !hasPaidItem;
                                    const shouldRender = !hasFreeItem;

                                    if (shouldRender) {
                                        allProductsHTML += `
                                            <div class="single_step_product_wrapper" id="${wrapperId}">
                                                <div class="free_product_wrapper_inner">
                                                    ${productElem.innerHTML}
                                                </div>
                                            </div>`;
                                    }
                                }


                                else {

                                        // 1. Remove accordion HTML
                                        const mainAccordion = document.querySelector('.main_free_product_accordion_wrapper');
                                        if (mainAccordion) {
                                            const productWrapper = mainAccordion.querySelector(`#${wrapperId}`);
                                            if (productWrapper) productWrapper.remove();
                                        }

                                        // 2. Remove only free variant from cart
                                        if (type === "product") {

                                            const matchedItems = cart.items.filter(item => {
                                                return item.product_id.toString() === productIdOnly.toString();
                                            });
                                            

                                            matchedItems.forEach(item => {
                                                if (Number(item.price) === 0) {
                                                    console.log("Removing free item:", item.variant_id);
                                                    // by line key when available: the variant-id remove link can hit a paid line of the same variant
                                                    if (typeof window.itgRemoveFreeGiftLine === 'function' && item.key) {
                                                        window.itgRemoveFreeGiftLine(item);
                                                    } else {
                                                        removeProductFromCart(item.variant_id);
                                                    }
                                                } else {
                                                    console.log("Keeping paid variant:", item.variant_id);
                                                }
                                            });
                                        }
                                    }

                                });

							let sidebarWrapper = document.querySelector('.sidebar__free_product_wrapper');

							let cartPageWrapper = document.querySelector('.cart-form__items .sidebar__free_product_wrapper');

							if (!cartPageWrapper && document.body.classList.contains('template-cart')) {
								const cartItemsWrapper = document.querySelector('.cart-form__items');
								if (cartItemsWrapper) {
									cartPageWrapper = document.createElement('div');
									cartPageWrapper.classList.add('sidebar__free_product_wrapper');
									cartItemsWrapper.appendChild(cartPageWrapper);

										if (allProductsHTML.trim() !== '') {
											const wrapper = document.createElement('div');
											wrapper.classList.add('main_free_product_accordion_wrapper');
											wrapper.innerHTML = `
												<div class="headerItg active" style="cursor:pointer; display:flex; justify-content:space-between; align-items:center;">
													<span class="productTitleItg">${itgFreeGiftLabel}</span>
													<span class="svg-wrapper accordion_down_icon">
														<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
															<path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/>
														</svg>
													</span>
												</div>
												<div class="free_product_wrapper" style="display:block;">
													<div class="free_product_inner_container">
														${allProductsHTML}
													</div>
												</div>
											`;

											// Toggle accordion
											wrapper.querySelector('.headerItg').addEventListener('click', () => {
												const content = wrapper.querySelector('.free_product_wrapper');
												content.style.display = content.style.display === 'block' ? 'none' : 'block';
											});

											cartPageWrapper.appendChild(wrapper);
										} else {
											cartPageWrapper.classList.add('hideWrapper');
										}
									
									}
								}else{
									let sidebarWrapper = document.querySelector('.cart-form__items .sidebar__free_product_wrapper');
									if (sidebarWrapper) {
										sidebarWrapper.innerHTML = '';
									}
								}       


							// CART DRAWER: clear previous content
							if (sidebarWrapper) {
								sidebarWrapper.innerHTML = '';
							}

						
							// Only build accordion if there are products
							if (allProductsHTML.trim() !== '') {
								const wrapper = document.createElement('div');
								wrapper.classList.add('main_free_product_accordion_wrapper');
								wrapper.innerHTML = `
									<div class="headerItg active" style="cursor:pointer; display:flex; justify-content:space-between; align-items:center;">
										<span class="productTitleItg">${itgFreeGiftLabel}</span>
										<span class="svg-wrapper accordion_down_icon">
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
												<path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/>
											</svg>
										</span>
									</div>
									<div class="free_product_wrapper" style="display:block;">
										<div class="free_product_inner_container">
											${allProductsHTML}
										</div>
									</div>
								`;

								// Toggle accordion
								wrapper.querySelector('.headerItg').addEventListener('click', () => {
									const content = wrapper.querySelector('.free_product_wrapper');
									content.style.display = content.style.display === 'block' ? 'none' : 'block';
								});

								sidebarWrapper.classList.remove('hideWrapper');
								sidebarWrapper.appendChild(wrapper);
							} else {
								sidebarWrapper.classList.add('hideWrapper');
							}
						})();



						// Filled bar
						if (!isNaN(cartPrice)) {
							let filledPercent = ((cartPrice * 100) / maxAmountPrice);
							filledPercent = Math.min(Math.max(filledPercent, 0), 100);

							const filledBar = cartBar.querySelector(".cart_drawer_filled_bar");
							if (filledBar) {
								filledBar.style.width = filledPercent + "%";

							}
						
						}

						// subtotalAmt Updated

						console.log(subTotalAmt);

						document.querySelector('.cart_drawer_progress_bar').setAttribute("data-cart-price" , subTotalAmt ) ;
						localStorage.setItem('loadedCartPrice', subTotalAmt);








            })
            .catch((error) => {
                console.error('Error updating cart contents:', error)
                displayCartAdditionError()
            })
    }

    function showCartOverlay() {
        if (
            !document.body.classList.contains('template-cart') &&
            KROWN.settings.cart_action === 'overlay'
        ) {
            document.getElementById('site-cart-sidebar').show()
            setTimeout(() => {
                document
                    .querySelector('#site-cart-sidebar [data-js-close]')
                    .focus()
            }, 200)
        }
    }

    //toggle
    function toggleLoading(isLoading) {
        const loadingSpinner = document.getElementById('loadingSpinner')
        const warrantyContent = document.getElementById('warranty-content')
        if (loadingSpinner) {
            loadingSpinner.style.display = isLoading ? 'block' : 'none'
        }
        if (warrantyContent) {
            warrantyContent.style.display = isLoading ? 'none' : 'flex'
        }
    }

    function toggleAddToCartButton(show) {
        if (addWarrantyButton) {
            addWarrantyButton.style.display = show ? 'flex' : 'none'
        }
    }

    //error handling
    function displayNoWarrantyError() {
        toggleLoading(false)
        if (warrantyVariantInfo) {
            warrantyVariantInfo.innerHTML =
                '<span>Please contact customer service with error code: W10001</span>'
        }
        toggleAddToCartButton(false)
    }

    function displayCartAdditionError() {
        toggleLoading(false)
        if (warrantyVariantInfo) {
            warrantyVariantInfo.innerHTML =
                '<span>There was an error adding warranty service to your cart. Please try again. (Error code: W10002)</span>'
        }
        toggleAddToCartButton(false)
    }

    function displayUnexpectedError() {
        toggleLoading(false)
        if (warrantyVariantInfo) {
            warrantyVariantInfo.innerHTML =
                '<span>An unexpected error occurred. Please try again or contact support. (Error code: W10003)</span>'
        }
        toggleAddToCartButton(false)
    }

    // On page load, display the warranty variant information.
    displayWarrantyProduct()

    const variantInfoWarrantyEl = document.getElementById('variantInfoWarranty')
    if (variantInfoWarrantyEl) {
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (
                    mutation.type === 'attributes' &&
                    mutation.attributeName === 'data-warranty'
                ) {
                    displayWarrantyProduct()
                }
            })
        })
        observer.observe(variantInfoWarrantyEl, { attributes: true })
    }
})

function getDeductible(price) {
    if (price >= 150 && price <= 200) {
        return '$50'
    } else if (price <= 600) {
        return '$100'
    } else if (price <= 1200) {
        return '$150'
    } else if (price <= 3000) {
        return '$200'
    } else if (price > 3000) {
        return '$250'
    } else {
        return 'Not applicable'
    }
}
